import { useCallback } from 'react';
import { useMutation } from 'src/graphql';
import { IMPORT_JOB_RESULTS } from 'src/graphql/job/mutation';

export default (jobId) => {
  const [importJobResults] = useMutation(IMPORT_JOB_RESULTS);

  return useCallback(
    ({
      jobToId,
      jobFromId,
      importChecklists,
      importDatasheets,
    }) => importJobResults({
      variables: {
        jobFromId,
        jobToId,
        importChecklists,
        importDatasheets,
      },
    }),
    [jobId],
  );
};
